import 'jquery.cookie'
export default function(opt) {

    var config = jQuery.extend({
        name: 'wielink_avg',
        emptyCSS: false,
        position: 'bottom',
        options: {
            necessary: 'Noodzakelijk',
            analytical: 'Analytisch',
            tracking: 'Tracking'
        },
        inputLabel: 'Sta de volgende cookies toe',
        firstRequired: true,
        buttonText: 'Accepteren',
        reset: false,
        content: '<p>Wij maken gebruik van <a style="text-decoration: underline; color: white;" href="/cookiebeleid/">cookies</a> om de website goed te laten functioneren. <br>Als je onze website gebruikt, gaan wij ervan uit dat je daarvoor toestemming geeft.</p>'
    }, typeof opt === 'object' ? opt : {});

    /* options */
    var optionshtml = '';
    jQuery.each(config.options, function (key, value) {
        var rchecked = 'checked="false" class="not-checked"';
        if (config.firstRequired === true && optionshtml === '') {
            rchecked = 'checked="true" onclick="return false;" class="disabled checked"';
        }
        var st = '';
        optionshtml = optionshtml + '<li ' + st + '><input type="checkbox" name="' + key + '" value="1" ' + rchecked + ' id="cookie_' + key + '" /> <label class="checkbox_label" for="cookie-' + key + '">' + value + '</label></li>';
    });

    var html = '<div class="cookie-bar">' +
        '<div class="cookie-bar-wrapper">' +
        '<div class="cookie-bar-top">' +
        config.content +
        '</div>' +
        '<div class="cookie-bar-bottom">' +
        '<ul><li>' + config.inputLabel + '</li>' + optionshtml + '<li><a class="btn" href="#">' + config.buttonText + '</a> </li></ul>' +
        '</div>' +
        '<div class="clear_div"></div>' +
        '</div>' +
        '</div>';
    try {
        if (typeof jQuery.cookie(config.name + '_cookies_accepted') === 'undefined' || config.reset) {
            if (config.position == 'top') {
                jQuery('body').prepend(html);
            } else {
                jQuery('body').append(html);
            }
            // set the clicks
            jQuery(document).ready(function() {
                jQuery('div.cookie-bar').find('label.checkbox_label').click(function () {
                    if (!(jQuery(this).prev().hasClass('disabled'))) {
                        jQuery(this).toggleClass('inactive');
                    }
                });
            });
            jQuery('.cookie-bar a.btn').click(function () {
                jQuery.each(config.options, function (key, value) {
                    if (!(jQuery('#cookie_' + key).next().hasClass('inactive'))) {
                        jQuery.cookie(config.name + '_cookies_' + key, '1', {expires: 365, path: '/'});
                    }
                });
                jQuery.cookie(config.name + '_cookies_accepted', '1', {expires: 365, path: '/'});
                jQuery('.cookie-bar').hide();
                location.href = location.href;
                return false;
            });
        }
    } catch (error) {
        console.log(error);
        console.log('Unable to find the cookie lib.');
    }
};